import {useState} from 'react';
import axios from 'axios';
import { toast} from 'react-toastify';
import { useSelector, useDispatch } from "react-redux";

import {
    handle_videoRecordStatus,
  } from "../../Redux/reducer";
import {
    get3DRecords,
  } from "../../Redux/actions";

export const FileUploader = ({onSuccess}) => {
    const dispatch = useDispatch();
    const [files, setFiles] = useState([]);
    const user = useSelector((state) => state.auth.user);

    function readImage(file) {
        // Check if the file is an image.
        if (file.type && !file.type.startsWith('image/')) {
          console.log('File is not an image.', file.type, file);
          return;
        }
      
        const reader = new FileReader();
        reader.addEventListener('load', (event) => {
        //   video.src = event.target.result;
            console.log("FileUploader:readImage:event.target.result = ",event.target.result);
        });
        // reader.readAsDataURL(file);
      }

    const onInputChange = (e) => {
        setFiles(e.target.files)
        console.log("FileUploader:onInputChange:e.target.files = ",e.target.files);
        readImage(e.target.files)
    };

    const onSubmit = (e) => {
        e.preventDefault();
        dispatch(get3DRecords())
        dispatch(handle_videoRecordStatus(true))
        const data = new FormData();
	var fileType;
        for(let i = 0; i < files.length; i++) {
            data.append('file', files[i]);
	    fileType = files[i].type;
	    console.log("Lohith:file type = ",fileType)
        }
        // data.append('data', user);
        //axios.post('//localhost:8000/upload', data)
        // axios.post('//169.38.82.69:8000/upload', data)
        //    .then((response) => {
        //        toast.success('Upload Success');
        //        onSuccess(response.data)
        //    })
        //    .catch((e) => {
        //        toast.error('Upload Error')
        //    })
        //fetch('//localhost:8000/upload', {
        //fetch('https://169.38.82.69:8000/upload', {
	//fetch('https://www.airender.co.in:8000/upload', {
        //    method: 'POST',
        //    body: data
        //})
        //.then((response) => {
        //    console.log(response);
        //    response.json().then((result)=>{ console.log(result) })
        //}) 
        //.catch((error) => {
        //    console.log(error);
        //})
	
	 //var hostPublicIp = "169.38.82.69";
	 //var host = 'https://' + hostPublicIp;
         var host = 'https://www.airender.co.in';
	 var port = 8000;
	 console.log("Lohith:FileUpload:user = ",user)
	 //console.log("Lohith:file type = ",data.type)
	 var toFile = Date.now()+'-'+user.uid+'.'+fileType.split('/')[1]
	 uploadDataToServer(host, port, data, toFile)
	
    };
    
    var https = require('https-browserify')

    function readLocalOrServerFile(file, type, asyncFlag, callback)
          {
            console.debug("Lohith:FileUpload: readLocalOrServerFile start",
              file, type, asyncFlag, callback);

            var request = new XMLHttpRequest();

            request.responseType = type;

            request.open("GET", file, asyncFlag);

            request.send();

            request.onreadystatechange = function ()
              {
                  if(request.readyState === 4)
                  {
                      if(request.status === 200 || request.status == 0)
                      {
                  console.debug("Lohith:FileUpload: readLocalOrServerFile success",
                    request.responseText);

                  callback(request.responseText);
                      }
                  }
              }

          }


    function uploadDataToServer(host, port, fromFileContents, toFile) {
            console.debug("Lohith:FileUpload:uploadDataToServer start",
              host, port, fromFileContents, toFile);
		
	    var key, cert, ca;
            var key_path = '/root/WORK/KEYS';

            readLocalOrServerFile(key_path+'/privkey.pem', 'text', true,
              (keyData) => {

                key = keyData;

                readLocalOrServerFile(key_path+'/cert.pem', 'text', true,
                  (certData) => {

                    cert = certData;

                    readLocalOrServerFile(key_path+'/chain.pem', 'text', true,
                      (caData) => {

                        ca = caData;
                        
                        const options = {
                          key,
                          cert,
                          ca: [ca],
                          //rejectUnauthorized: false
                        };
                        
                        var agent = new https.Agent(options);

                        var url = host + ':' + port + '/' + toFile;

                        console.debug("Lohith:FileUpload:uploadDataToServer start fetch", url, options, fromFileContents);

                        fetch(url, {
                          method: 'POST',
                          mode: 'no-cors',
                          body: fromFileContents,
                          agent
                        }).then(
                          success => {console.debug("Lohith:FileUpload:uploadDataToServer fetch success", success);}
                        ).catch(
                          error => {console.debug("Lohith:FileUpload:uploadDataToServer fetch error", error);}
                        );

			//var request = new XMLHttpRequest();
			//var currTime = new Date().getTime();
			//request.open("HEAD", url, true);
            		//request.send(currTime);
			//request.onreadystatechange = function () {
                	//    if (this.readyState === this.DONE) {
                  	//        if(this.status === 200) {
                    	//	    console.info("Lohith: fileURL exists",url)
                  	//	} else {
                    	//	    console.info("Lohith: fileURL doesnt exist",url)
                  	//	}
                	//    }
              		//};
			
			//var params = {
			//    currTime: new Date().getTime()
			//}
			//const http = new XMLHttpRequest()
        		//http.open('POST', url, true)
        		//http.setRequestHeader('Content-type', 'application/json')
        		//http.send(JSON.stringify(params)) // Make sure to stringify
        		//http.onload = function() {
            		    // Do whatever with response
            		    //alert(http.responseText)
			//    console.info("Lohith: http.onload: http.responseText",http.responseText)
        		//}
                      }
                    );//end readLocalOrServerFile('certificates/ca-cert.pem', 'text', true,

                  }
                );//end readLocalOrServerFile('certificates/client-cert.pem', 'text', true,

              }
            );//end readLocalOrServerFile('certificates/client-key.pem', 'text', true,

          };

    return (
        files.length > 0 ? 
        <div 
            className="hiRenderDemo-upload-button" 
            onClick={onSubmit}
        >
            SUBMIT
        </div>
        : <>
            <input
                type="file"
                accept="video/*"
                style={{ display: "none" }}
                id="contained-button-file"
                onChange={onInputChange}
            />
            <label
                className="hiRenderDemo-upload-button"
                htmlFor="contained-button-file"
            >
                UPLOAD YOUR FILE
            </label>
        </>
    )
};
